import React from 'react';

const ProfileCompletionNudge = ({ completeness, missingFields, onCompleteProfile, onDismiss }) => {
  if (completeness >= 75) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
      onClick={onDismiss}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 24,
          width: '100%',
          maxWidth: 380,
          padding: '28px 24px 24px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        }}
      >
        {/* Close */}
        <button
          onClick={onDismiss}
          style={{
            position: 'absolute', top: 16, right: 16,
            background: 'none', border: 'none',
            cursor: 'pointer', color: '#AFA99F',
            display: 'flex', alignItems: 'center', padding: 4,
          }}
          aria-label="Dismiss"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </button>

        {/* Heading */}
        <h3 style={{ fontSize: 18, fontWeight: 700, color: '#1A1A1A', margin: '0 0 6px' }}>
          Your profile is {completeness}% complete
        </h3>
        <p style={{ fontSize: 14, color: '#666', lineHeight: 1.5, margin: '0 0 20px' }}>
          Fill in a few more details so Son:mi can give you more accurate shade matches and recommendations.
        </p>

        {/* Progress bar */}
        <div style={{
          height: 4, background: '#F0EBE5', borderRadius: 2,
          overflow: 'hidden', marginBottom: 20,
        }}>
          <div style={{
            height: '100%', width: `${completeness}%`,
            background: '#341C1C', borderRadius: 2,
            transition: 'width 0.6s ease',
          }} />
        </div>

        {/* Missing fields */}
        {missingFields && missingFields.length > 0 && (
          <div style={{ marginBottom: 22 }}>
            <p style={{ fontSize: 13, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 8px' }}>
              Still missing
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {missingFields.slice(0, 4).map((field, i) => (
                <span key={i} style={{
                  fontSize: 13, padding: '4px 11px',
                  background: '#F5F0EB', borderRadius: 20,
                  color: '#341C1C', fontWeight: 500,
                }}>
                  {field}
                </span>
              ))}
              {missingFields.length > 4 && (
                <span style={{
                  fontSize: 13, padding: '4px 11px',
                  background: '#341C1C', borderRadius: 20,
                  color: 'white', fontWeight: 500,
                }}>
                  +{missingFields.length - 4} more
                </span>
              )}
            </div>
          </div>
        )}

        {/* CTA */}
        <button
          onClick={onCompleteProfile}
          style={{
            width: '100%', padding: 14, border: 'none',
            borderRadius: 100, background: '#341C1C', color: 'white',
            fontSize: 15, fontWeight: 600, cursor: 'pointer', marginBottom: 10,
          }}
        >
          Complete my profile
        </button>

        <button
          onClick={onDismiss}
          style={{
            width: '100%', padding: 12, border: 'none',
            borderRadius: 100, background: 'transparent', color: '#AFA99F',
            fontSize: 14, fontWeight: 500, cursor: 'pointer',
          }}
        >
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default ProfileCompletionNudge;
